import Vue from 'vue'
import FlowHtml from './FlowHtml'
import './plugins/frontend/plugins'

// Sets app environment to false
Vue.config.productionTip = true

// Inits vue app
new Vue({
  render: h => h(FlowHtml),
}).$mount('#xit-flow-builder')
